<template>
  <div :class="header == 'on' ? 'flight-detail' : 'flight-detail-ios'">
    <van-nav-bar left-arrow
                 :fixed="true"
                 @click-left="$router.back()"
                 v-if="header == 'on'">
      <div slot="title" style="line-height: 35px;">
        <span class="flightNo">{{flight.FlightDepcode}} - {{flight.FlightArrcode}}</span>
        <span class="deparr">{{flight.FlightDeptimePlanDate | moment('ddd, Do MMM') }}</span>
      </div>
    </van-nav-bar>
    <div class="map">
      <Map/>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="xiala" pulling-text=" " loading-text=" "
                      loosing-text=" ">
      <div slot="pulling" class="bg-load"><img :src="loadImg"/></div>
      <div slot="loosing" class="bg-load"><img :src="loadImg"/></div>
      <div slot="loading" class="bg-load"><img :src="loadImg"/></div>
      <div class="container">
        <div class="flight-card">
          <div :class="'card-head flight-status-block ' + flight.FlightState">
            <div class="flight-number">{{flight.FlightNo}}</div>
            <div class="flight-status" v-if="flight.FlightState && flight.FlightState.includes('cancel')">
              <span class="status">{{ $t('Cancel') }}</span>
              <span> · </span>
              <span class="time">Contact the airline </span>
            </div>

            <div class="flight-status" v-else-if="flight.FlightState === 'delay'">
              <span class="status">{{ $t('Delay') }} </span>
              <span v-if="isArrival == 1">{{ delayTimeArr }}</span>
              <span v-if="isArrival == 0">{{ delayTime }}</span>
              <span v-if="delayCountArr && isArrival == 1"> · {{ $t('Arrivals in')}}<i class="time-count">{{ delayCountArr }}</i> </span>
              <span v-if="delayCount && isArrival == 0"> · {{ $t('Departs in') }}<i
                class="time-count">{{ delayCount }}</i> </span>
            </div>

            <div class="flight-status" v-else>
              <span v-if="isArrival == 1">
                <span class="time" v-if="flight.FlightState === 'arrival'">{{ $t('arrivalDetail') }}</span>
                <span class="time" v-else>{{ $t('schedule') }}</span>
              </span>
              <span class="time" v-else>{{ $t('Schedule') }}</span>
              <span v-if="!countTextArr && isArrival == 1"> · {{ $t('Arrive at') }} {{ renderText(arrTimeDisplay, true) }} </span>
              <span v-if="!countText && isArrival == 0"> · {{ $t('Departs at') }} {{ renderText(depTimeDisplay, true) }} </span>
              <span v-if="countTextArr && isArrival == 1"> · {{ $t('Arrivals in') }}<i class="time-count">{{ countTextArr }}</i> </span>
              <span v-if="countText && isArrival == 0"> · {{ $t('Departs in') }}<i
                class="time-count">{{ countText }}</i> </span>
            </div>

          </div>
          <div class="card-body">
            <ul class="timeline">
              <li>
                <div class="time">
                  <div v-if="flight.FlightState === 'delay'">
                    <del>{{ renderText(flight.FlightDeptimePlanDate, true) }}</del>
                    <p>{{ renderText(getDelayDate(), true) }}</p>
                  </div>
                  <div v-else>
                    <p
                      v-if="!flight.FlightDeptimeDate || formatDate(flight.FlightDeptimeDate) <= formatDate(flight.FlightDeptimePlanDate)">
                      {{renderText(flight.FlightDeptimePlanDate, true)}}</p>
                    <del v-if="formatDate(flight.FlightDeptimeDate) > formatDate(flight.FlightDeptimePlanDate)">
                      {{renderText(flight.FlightDeptimePlanDate, true)}}
                    </del>
                    <p v-if="formatDate(flight.FlightDeptimeDate) > formatDate(flight.FlightDeptimePlanDate)">
                      {{renderText(flight.FlightDeptimeDate, true)}}</p>
                  </div>
                  <div class="direction">{{ $t('DepartDetail') }}</div>
                </div>
                <div class="time-point"></div>
                <div class="label">
                  <div class="airport">
                    <span class="code">{{flight.FlightDepcode}}</span>
                    <span class="name">{{flight.FlightDep}}</span>
                  </div>
                  <div class="info">
                    <div class="terminal">
                      <span>{{ $t('Terminal') }}</span>
                      <span class="darker">{{renderText(flight.FlightHTerminal)}}</span>
                    </div>
                    <div class="gate">
                      <span>{{ $t('Gate') }}</span>
                      <span class="darker">{{renderText(flight.BoardGate)}}</span>
                    </div>
                    <div class="baggage"></div>
                  </div>
                </div>
              </li>

              <li>
                <div class="time">
                  <div v-if="flight.FlightState === 'delay'">
                    {{ (arrReadyDate = flight.FlightArrtimeReadyDate || flight.VeryZhunReadyArrtimeDate, void 0) }}
                    <del>{{renderText(flight.FlightArrtimePlanDate, true)}}</del>
                    <p>{{ renderText(arrReadyDate, true) }}</p>
                  </div>
                  <div v-else>
                    <p
                      v-if="!flight.FlightArrtimeDate || formatDate(flight.FlightArrtimeDate) <= formatDate(flight.FlightArrtimePlanDate)">
                      {{renderText(flight.FlightArrtimePlanDate, true)}}</p>
                    <del v-if="formatDate(flight.FlightArrtimeDate) > formatDate(flight.FlightArrtimePlanDate)">
                      {{renderText(flight.FlightArrtimePlanDate, true)}}
                    </del>
                    <p v-if="formatDate(flight.FlightArrtimeDate) > formatDate(flight.FlightArrtimePlanDate)">
                      {{renderText(flight.FlightArrtimeDate, true)}}</p>
                  </div>
                  <div class="direction">{{ $t('Arrive') }}</div>
                </div>
                <div class="time-point"></div>
                <div class="label">
                  <div class="airport">
                    <span class="code">{{renderText(flight.FlightArrcode)}}</span>
                    <span class="name">{{renderText(flight.FlightArr)}}</span>
                  </div>
                  <div class="info">
                    <div class="terminal">
                      <span>{{ $t('Terminal') }}</span>
                      <span class="darker">{{renderText(flight.FlightTerminal)}}</span>
                    </div>
                    <div class="gate">
                      <span>{{ $t('Gate') }}</span>
                      <span class="darker">{{renderText(flight.ReachExit)}}</span>
                    </div>
                    <div class="baggage">
                      <span>{{ $t('Baggage') }}</span>
                      <span class="darker">{{renderText(flight.BaggageID)}}</span>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
            <div class="duration">
              <div class="label">{{ $t('Duration') }}</div>
              <div class="value">{{timeConvert(flight.FlightDuration)}}</div>
            </div>
          </div>
        </div>

        <van-cell-group class="darker-title aircraft-title">
          <van-cell :title="$t('Aircraft')" :value="flight.generic"/>
        </van-cell-group>

        <!-- <van-cell-group>
          <van-cell :title="$t('View terminal map')" is-link :value="flight.FlightDepcode" @click="coming"/>
          <van-cell :title="$t('View terminal map')" is-link :value="flight.FlightArrcode" @click="coming"/>
        </van-cell-group> -->

        <van-cell-group class="darker-title">
          <van-cell :title="$t('DepartDetail') + ' · ' + flight.FlightDepAirport"/>
        </van-cell-group>

        <van-cell-group>
          <van-cell :border="false">
            <div class="flight-info-cell">
              <div class="item">
                <div class="label">{{ $t('ScheduleStatus') }}</div>
                <div class="value">{{renderText(flight.FlightDeptimePlanDate, true)}}</div>
              </div>

              <div class="item">
                <div class="label">{{ $t('Estimated') }}</div>
                <div class="value">{{ renderText(getDelayDate(), true) }}</div>
              </div>

              <div class="item">
                <div class="label">{{ $t('Actual') }}</div>
                <div class="value">{{renderText(flight.FlightDeptimeDate, true)}}</div>
              </div>
            </div>
          </van-cell>
        </van-cell-group>

        <van-cell-group class="darker-title">
          <van-cell :title="$t('Arrive') + ' · ' + flight.FlightArrAirport"/>
        </van-cell-group>

        <van-cell-group>
          <van-cell>
            <div class="flight-info-cell">
              <div class="item">
                <div class="label">{{ $t('ScheduleStatus') }}</div>
                <div class="value">{{renderText(flight.FlightArrtimePlanDate, true)}}</div>
              </div>

              <div class="item">
                <div class="label">{{ $t('Estimated') }}</div>
                <div class="value">{{renderText(flight.FlightArrtimeReadyDate, true)}}</div>
              </div>

              <div class="item">
                <div class="label">{{ $t('Actual') }}</div>
                <div class="value">{{renderText(flight.FlightArrtimeDate, true)}}</div>
              </div>
            </div>
          </van-cell>
        </van-cell-group>
        <van-cell-group class="darker-title">
          <van-cell :title="$t('On time Rate')" :value="flight.OntimeRate == '0.00%' ? '00.00%' : flight.OntimeRate "/>
        </van-cell-group>

      </div>
    </van-pull-refresh>
    <p class="power">Data powered by VariFlight</p>
  </div>
</template>

<script>
import { parse } from 'path'
import Map from '../components/Map'
import { changeTimeByTimezone } from '../util'
// import { monitorEventLoopDelay } from 'perf_hooks';
export default {
  name: 'Detail',
  data () {
    return {
      isLoading: false,
      header: sessionStorage.getItem('header'),
      flight: {},
      timer: null,
      countText: '',
      countTextArr: '',
      depTimeDisplay: null,
      arrTimeDisplay: null,
      loadImg: 'data:image/gif;base64,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',
      delayTime: '',
      delayTimeArr: '',
      delayCount: null,
      delayCountArr: null,
      isArrival: null
    }
  },
  components: { Map },
  mounted () {
    this.flight = this.$store.state.flight
    this.updateFlight()
    if (this.flight.FlightState === 'delay') {
      this.getDelayDate()
    }
  },
  methods: {
    renderText (text, isTime = false) {
      if (!text) {
        return '--'
      }
      if (isTime) {
        text = this.$moment(text).format('HH:mm')
      }
      return text
    },
    formatDate (time) {
      if (!time) {
        return
      }
      return new Date(time.replace(/-/g, '/')).getTime()
    },
    updateFlight () {
      let url = this.$urlHelper.byDetail(this.$route.query)
      this.$http.get(url).then(response => {
        if (response.status === 200 && !response.data.error) {
          let flights = response.data.filter(item => item.FlightNo === this.$route.query.fnum && item.FlightDepcode === this.$route.query.dep && item.FlightArrcode === this.$route.query.arr)
          if (flights.length === 1) {
            this.$store.commit('setFlight', flights[0])
          }
        }
      })
    },
    coming () {
      this.$toast('Coming soon!')
    },
    timeConvert (n) {
      if (!n) {
        return '--'
      }
      var hours = (n / 60)
      var rhours = Math.floor(hours)
      var minutes = (hours - rhours) * 60
      var rminutes = Math.round(minutes)
      return rhours + this.$t('h') + rminutes + this.$t('min')
    },
    onRefresh () {
      this.updateFlight()
      setTimeout(function () {
        this.isLoading = false
      }.bind(this), 500)
    },
    getDelayTime () {
      if (!this.flight.FlightDeptimeReadyDate && !this.flight.VeryZhunReadyDeptimeDate) {
        this.delayTime = ''
        return
      }
      let delayDate = this.getDelayDate()
      let delayTime = this.formatDate(delayDate) - this.formatDate(this.flight.FlightDeptimePlanDate)
      let h = parseInt(delayTime / 1000 / 60 / 60)
      let m = Math.ceil(delayTime / 1000 / 60 % 60)
      if (h < 1) {
        this.delayTime = m + this.$t('min')
      } else {
        this.delayTime = h + this.$t('h') + m + this.$t('min')
      }
      this.timer = setInterval(() => {
        let date = this.timeChange(new Date(changeTimeByTimezone(this.flight.org_timezone)), delayDate).split(',')
        if (date.length === 1) {
          this.delayCount = ''
          return
        }
        this.delayCount = String(date[0]) + ':' + String(date[1]) + ':' + String(date[2])
      }, 1000)
    },

    getDelayTimeArr () {
      if (!this.flight.FlightArrtimeReadyDate && !this.flight.VeryZhunReadyArrtimeDate) {
        this.delayTimeArr = ''
        return
      }
      let delayDate = this.getDelayDate1()
      let delayTime = this.formatDate(delayDate) - this.formatDate(this.flight.FlightArrtimePlanDate)
      let h = parseInt(delayTime / 1000 / 60 / 60)
      let m = Math.ceil(delayTime / 1000 / 60 % 60)
      if (h < 1) {
        this.delayTimeArr = m + this.$t('min')
      } else {
        this.delayTimeArr = h + this.$t('h') + m + this.$t('min')
      }
      this.timer = setInterval(() => {
        let date = this.timeChange(new Date(changeTimeByTimezone(this.flight.dst_timezone)), delayDate).split(',')
        if (date.length === 1) {
          this.delayCountArr = ''
          return
        }
        this.delayCountArr = String(date[0]) + ':' + String(date[1]) + ':' + String(date[2])
      }, 1000)
    },
    countDown () {
      this.timer = setInterval(() => {
        let date = this.timeChange(new Date(changeTimeByTimezone(this.flight.org_timezone)), this.depTimeDisplay).split(',')
        if (date.length === 1) {
          this.countText = ''
          return
        }
        this.countText = String(date[0]) + ':' + String(date[1]) + ':' + String(date[2])
      }, 1000)
    },
    countDown1 () {
      this.timer = setInterval(() => {
        let date = this.timeChange(new Date(changeTimeByTimezone(this.flight.dst_timezone)), this.arrTimeDisplay).split(',')
        if (date.length === 1) {
          this.countTextArr = ''
          return
        }
        this.countTextArr = String(date[0]) + ':' + String(date[1]) + ':' + String(date[2])
      }, 1000)
    },
    timeChange (starttime, endtime) {
      if (!endtime) {
        clearInterval(this.timer)
        return ''
      }
      let now = new Date(starttime).getTime()
      let depTimeDisplay = endtime.replace(/-/g, '/')
      let flight = new Date(depTimeDisplay).getTime()
      let time = parseInt(flight) - parseInt(now)
      if (time <= 0) {
        clearInterval(this.timer)
        return ''
      }
      let hours = parseInt(time / 1000 / 60 / 60)
      let minutes = parseInt(time / 1000 / 60 % 60)
      let seconds = parseInt(time / 1000 % 60)
      if (hours <= 0) {
        hours = '00'
      } else {
        hours = hours < 10 ? '0' + hours : hours
      }
      if (minutes <= 0) {
        minutes = '00'
      } else {
        minutes = minutes < 10 ? '0' + minutes : minutes
      }
      if (seconds <= 0) {
        seconds = '00'
      } else {
        seconds = seconds < 10 ? '0' + seconds : seconds
      }
      let date = hours + ',' + minutes + ',' + seconds
      return date
    },
    getDelayDate () {
      let delayDate
      if (this.flight.FlightDeptimeReadyDate && this.formatDate(this.flight.FlightDeptimeReadyDate) > new Date().getTime()) {
        delayDate = this.flight.FlightDeptimeReadyDate
      } else {
        delayDate = this.flight.VeryZhunReadyDeptimeDate
      }
      return delayDate
    },
    getDelayDate1 () {
      let delayDate
      if (this.flight.FlightArrtimeReadyDate && this.formatDate(this.flight.FlightArrtimeReadyDate) > new Date().getTime()) {
        delayDate = this.flight.FlightArrtimeReadyDate
      } else {
        delayDate = this.flight.VeryZhunReadyArrtimeDate
      }
      return delayDate
    }
  },
  watch: {
    '$store.state.flight' () {
      this.flight = this.$store.state.flight
      clearInterval(this.timer)
    },
    flight () {
      this.isArrival = localStorage.getItem('isArrival')
      this.depTimeDisplay = this.flight.FlightDeptimeDate || this.flight.FlightDeptimeReadyDate || this.flight.FlightDeptimePlanDate
      this.arrTimeDisplay = this.flight.FlightArrtimeDate || this.flight.FlightArrtimePlanDate || this.flight.FlightArrtimeReadyDate
      let status = ['cancel in advance', 'cancel', 'delay']
      if (this.flight.FlightState && status.indexOf(this.flight.FlightState) === -1) {
        if (this.isArrival == 0) {
          this.timeChange(new Date(changeTimeByTimezone(this.flight.org_timezone)), this.depTimeDisplay)
          this.countDown()
        } else {
          this.timeChange(new Date(changeTimeByTimezone(this.flight.dst_timezone)), this.arrTimeDisplay)
          this.countDown1()
        }
      }
      if (this.flight.FlightState === 'delay') {
        if (this.isArrival == 0) {
          let delayDate = this.getDelayDate()
          this.timeChange(new Date(changeTimeByTimezone(this.flight.org_timezone)), delayDate)
          this.getDelayTime()
        } else {
          let delayDate = this.getDelayDate1()
          this.timeChange(new Date(changeTimeByTimezone(this.flight.dst_timezone)), delayDate)
          this.getDelayTimeArr()
        }

      }
    }
  }
}
</script>

<style scoped lang="scss">
  .van-cell-group {
    height: auto;
    border: none;
  }

  .flight-detail {
    padding-top: 60px;
  }

  .flight-detail-ios {
    padding-top: 10px;
  }

  .flight-card {
    border: 1px solid rgb(211, 222, 233);
    margin-bottom: 6px;

    .card-head {
      color: white;
      padding: 8px;
      text-align: center;

      .flight-status {
        font-weight: bold;
        font-size: 16px;

        .time-count {
          display: inline-block;
          width: 80px;
          font-style: normal;
        }
      }
    }

    .card-body {
      padding: 8px;
      background: white;

      .count-down {
        text-align: center;
        font-family: '微软雅黑';
        font-size: 14px;
        color: #888;
      }

      .duration {
        padding: 6px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #EFEEF3;

        .label {
          font-size: 0.8em;
          color: #757576;
        }

        .value {
          color: #1b1b1d;
          /*font-family: 'Roboto Mono', Monaco, courier, monospace;*/
        }
      }
    }
  }

  .xiala {
    position: relative;
    top: -16px;
    z-index: 999;
  }

  .xiala .bg-load {
    background: #F4F3F2;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .timeline {
    margin: 30px 0 0 0;
    padding: 0;
    list-style: none;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 2px;
      background: #afdcf8;
      left: 20%;
      margin-top: 4em;
      margin-bottom: 4em;
    }

    li {
      position: relative;
      display: flex;
      align-items: center;
      padding: 4px 0;
    }

    .time {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 25%;

      p {
        margin: 0;
      }

      del {
        color: #666;
      }

      .direction {
        color: rgb(156, 166, 176);
        font-size: 0.9em;
      }
    }

    .time-point {
      position: absolute;
      left: 20%;
      width: 2px;
      height: 2px;
      line-height: 40px;
      -webkit-font-smoothing: antialiased;
      color: #fff;
      background: #46a4da;
      border-radius: 50%;
      box-shadow: 0 0 0 4px #afdcf8;
      text-align: center;
    }

    .label {
      flex: 1;
      border: 1px dashed rgb(211, 222, 233);
      padding: 0.8em;
      font-size: 1.2em;
      font-weight: 300;
      line-height: 1.4;
      position: relative;
      border-radius: 5px;
      color: #666;

      .darker {
        color: #666;
        font-weight: bold;
      }

      .airport {
        padding: 0 0.5em;
        color: #333;

        .code {
          font-size: 0.8em;
          font-weight: bold;
          border: 1px solid #666;
          border-radius: 4px;
          padding: 0 4px;
          margin-right: 1em;
        }
      }

      .info {
        display: flex;
        font-size: 0.8em;

        div {
          display: flex;
          flex-direction: column;
          margin: 5px;
        }
      }
    }
  }

  .darker-title {
    .van-cell {
      background: #F3F3F2;
      color: #433f33;
      font-weight: bold;
      font-family: "SF UI Text Regular", serif;
      font-size: 16px;
    }
  }

  .aircraft-title {
    .van-cell {
      background: #fff;
    }
  }

  .van-cell-group__title {
    background: #D7E0E9;
    color: #433f33;
    font-weight: bold;
    font-family: "SF UI Text Regular", serif;
    font-size: 16px;
  }

  .flight-info-cell {
    .item {
      display: flex;
      justify-content: space-between;
    }
  }

  .power {
    margin: 0;
    padding: 10px 0 15px;
    text-align: center;
    font-size: 13px;
    color: #666;
  }

</style>
